<template>
	<div>
		<div class="d-flex justify-space-between align-center mb-2 mt-6">
			<div class="input-wrap">
				<h5 class="mb-2">Reporte de comandas</h5>
			</div>
			<div class="action-btn-wrap">
				<v-btn v-if="records.length > 0" color="accent" @click="clickDownloadExcel()">
					<v-icon left small>mdi-file-excel</v-icon> Exportar Excel
				</v-btn>
			</div>
		</div>
		<v-card color="secondary" class="pa-3">
			<v-row dense>
				<v-col cols="12" xl="2" lg="2" md="2" sm="6">
					<div class="form-group">
						<label class="control-label">Desde</label>
						<el-date-picker
							v-model="search.start"
							type="date"
							value-format="yyyy-MM-dd"
							format="dd/MM/yyyy"
							:picker-options="pickerOptions"
						></el-date-picker>
					</div>
				</v-col>
				<v-col cols="12" xl="2" lg="2" md="2" sm="6">
					<div class="form-group">
						<label class="control-label">Hasta</label>
						<el-date-picker
							v-model="search.end"
							type="date"
							value-format="yyyy-MM-dd"
							format="dd/MM/yyyy"
							:picker-options="pickerOptionsDates"
						></el-date-picker>
					</div>
				</v-col>
				<v-col cols="12" xl="2" lg="2" md="2" sm="6">
					<div class="form-group">
						<label class="control-label">Mozo</label>
						<el-select v-model="search.waiter_id" filterable clearable>
							<el-option
								v-for="user in waiters"
								:key="user.id"
								:label="user.name"
								:value="user.id"
							></el-option>
						</el-select>
					</div>
				</v-col>
				<v-col cols="12" xl="2" lg="2" md="2" sm="6">
					<div class="form-group">
						<label class="control-label">Estado</label>
						<el-select v-model="search.state">
							<el-option
								v-for="user in states"
								:key="user.id"
								:label="user.name"
								:value="user.id"
							></el-option>
						</el-select>
					</div>
				</v-col>
				<v-col cols="12" xl="2" lg="4" md="12" sm="12">
					<el-button
						type="primary"
						icon="el-icon-search"
						class="btn-block mt-5"
						:loading="loading"
						@click="getData"
					></el-button>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="12" xl="12" lg="12">
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<td class="text-right">N°</td>
									<td>Fecha</td>
									<td>Número</td>
									<td>Cliente</td>
									<td>Vendedor(a)</td>
									<td>Estado</td>
									<td class="text-right">Total</td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(row, index) in records" :key="index">
									<td class="text-right">
										{{ index + 1 }}
									</td>
									<td>{{ row.date_of_issue }}</td>
									<td>{{ row.identifier }}</td>
									<td>{{ row.customer }}</td>
									<td>{{ row.waiter }}</td>
									<td>
										{{ row.state_description }}
									</td>
									<td class="text-right">
										<strong>{{ row.total }}</strong>
									</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td colspan="5"></td>
									<td><strong class="font-black">Total S/</strong></td>
									<td class="text-right table-success">
										<strong>{{ balance }}</strong>
									</td>
								</tr>
							</tfoot>
						</template>
					</v-simple-table>
				</v-col>
			</v-row>
		</v-card>
	</div>
</template>

<script>
import dayjs from 'dayjs';
export default {
	data() {
		return {
			resource: 'reports/commands',
			records: [],
			waiters: [],
			states: [
				{'id': 'delivered', 'name': 'Entregado'},
				{'id': 'cancelled', 'name': 'Cancelado'},
			],
			loading: false,
			balance: 0.0,
			search: {
				start: dayjs()
					.startOf('month')
					.format('YYYY-MM-DD'),
				end: dayjs().format('YYYY-MM-DD'),
				state: 'delivered',
				waiter_id: null,
			},
			pickerOptions: {
				disabledDate: (time) => {
					time = dayjs(time).format('YYYY-MM-DD');
					return dayjs().format('YYYY-MM-DD') < time;
				},
			},
			pickerOptionsDates: {
				disabledDate: (time) => {
					time = dayjs(time).format('YYYY-MM-DD');
					return this.search.start > time;
				},
			},
		};
	},
	created() {
		this.getTables();
	},
	methods: {
		getTables() {
			this.$http.get(`/${this.resource}/tables`).then((response) => {
				this.waiters = response.data;
			});
		},
		async getData() {
			this.loading = true;
			await this.$http.post(`/${this.resource}/records`, this.search).then((response) => {
				this.records = response.data.records;
				this.balance = response.data.balance;

				this.loading = false;
			});
		},
		clickDownloadExcel() {
			this.$http({
				url: `/${this.resource}/excel`,
				method: 'GET',
				responseType: 'blob',
			}).then((response) => {
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'ReporteComandas.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
		},
	},
};
</script>
